import {useEffect} from "react";
import CrmGroupListItem from './CrmGroupListItem.js';
import {useDispatch, useSelector} from "react-redux";
import {getGroupsAction} from "../store/actions/groupsActions";
import getGroupsSelector from "../store/selectors/groupsSelectors";


import { Menu } from 'antd';
import {setCatProductAction} from "../store/actions/productActions";



function CrmGroupList() {

    const data = useSelector(getGroupsSelector)
    //const data = useSelector(state => state.groupsState)

    const dispatch = useDispatch()

    //dispatch({type: "ADD_TEST", payload: 5})

    useEffect(() => {
        dispatch(getGroupsAction())
    }, [])



    function fetchGroups(groups) {
        return groups?.map((group) => (
        <CrmGroupListItem
            key={ group.id }
            id={ group.id }
            name={ group.name }
            subGroup={group.children.length ? true : false}
            children={ group.children }
        />));
    }

    let groupsData = [];
    if (data.groups) {
        function formatGroups(arr) {
            groupsData = arr.map(item => ({
                ...item,
                keys: item.keys,
                children: item.children.length ? formatGroups(item.children) : undefined,
            }));
            return groupsData;
        }
        formatGroups(data.groups);
    }




    const onClick = (e) => {
        console.log('click ', e.key);
        dispatch(setCatProductAction(e.key))
    };



    return (

<>
    <Menu
        onClick={onClick}
        style={{
            width: 456,
        }}
        mode="inline"
        items={groupsData}
    />

</>
    );
}

export default CrmGroupList;



